import React from "react";
import Marquee from "react-fast-marquee";

const AGENCIES = [
  "Federal Tax Authority",
  "Government of Dubai",
  "UAE Ministry of Finance",
  "Dubai Health Authority",
  "Emirates Identity Authority",
  "Dubai Economic Department",
  "Dubai Police",
  "Ministry of Human Resources",
];

export default function AgenciesV2() {
  return (
    <section
      data-testid="v2-agencies"
      className="relative bg-white py-10 md:py-14"
    >
      <div className="container-x text-center max-w-3xl mx-auto mb-6">
        <p className="overline text-[#3366FF]">Government relations</p>
        <div className="gold-rule mt-5 mb-6 mx-auto" />
        <h2 className="font-heading font-light tracking-tight text-[#0F172A] text-2xl sm:text-3xl leading-tight">
          We work closely with{" "}
          <span className="font-black text-[#002366]">all government agencies</span>.
        </h2>
        <p className="mt-4 text-slate-600">
          Always on the same page with UAE authorities — so your file moves
          forward, not sideways.
        </p>
      </div>

      <div className="border-y border-slate-200 bg-[#F8FAFC]">
        <Marquee speed={30} gradient={false} pauseOnHover className="py-6 md:py-8">
          {AGENCIES.concat(AGENCIES).map((a, i) => (
            <span
              key={`${a}-${i}`}
              className="mx-8 md:mx-14 font-heading font-bold tracking-tight text-[#002366]/80 whitespace-nowrap text-base md:text-lg flex items-center gap-8 md:gap-14"
            >
              {a}
              <span className="w-1.5 h-1.5 rounded-full bg-[#3366FF]/60" />
            </span>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
